module.exports = __webpack_public_path__ + "static/img/Permiso(1).c5d8b52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(1).jpg
// module id = bXiN
// module chunks = 0